import PropTypes from 'prop-types';
import React from 'react';
import omit from 'lodash.omit';

import StyledContainer from './container.style';
import { DebugGrid } from '../../../stylesheets/tools';

const Container = props => {
  const {
    children,
    tag = 'div',
    noDebugGrid = false,
    large = false,
    fill = false,
    fillOnMobile = false,
    className
  } = props;

  return (
    <StyledContainer
      as={tag}
      large={large}
      fill={fill}
      fillOnMobile={fillOnMobile}
      className={className}
      {...omit(props, ['tag', 'children'])}
    >
      <div className="container__wrapper">
        {children}
        {process.env.NODE_ENV === 'development' && !noDebugGrid ? <DebugGrid /> : ''}
      </div>
    </StyledContainer>
  );
};

Container.propTypes = {
  children: PropTypes.node,
  tag: PropTypes.string,
  noDebugGrid: PropTypes.bool,
  large: PropTypes.bool,
  fill: PropTypes.bool,
  fillOnMobile: PropTypes.bool,
  className: PropTypes.string
};

export default Container;
